// components/BookingModal/ErrorMessage.js
import React from "react";
import styles from "./styles.module.scss";

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorIcon}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
            fill="#D32F2F"
          />
        </svg>
      </div>
      <span className={styles.errorText}>{message}</span>
    </div>
  );
};

export default ErrorMessage;